import IndividualLayout from '../../components/IndividualLayout';
import BankInformation from './forms/BankInformation';
import ClientClassification from './forms/ClientClassification';
import EmployerInformation from './forms/EmployerInformation';
import DocumentVault from './forms/DocumentVault';
import PersonalInformation from './forms/PersonalInformation';
import GeneralInformation from './forms/GeneralInformation';
import InvestmentInformation from './forms/InvestmentInformation';
import SubmitApplication from './forms/SubmitApplication';
import IndividualFunctional from './index.function';
import ContactInformation from './forms/ContactInformation';
import TaxDeclaration from './forms/TaxDeclaration';

const IndividualForm = () => {
  const { step, onStepChange } = IndividualFunctional();

  return (
    <IndividualLayout step={step} setStep={onStepChange}>
      {step === 0 ? (
        <PersonalInformation onDone={() => onStepChange(1)} />
      ) : step === 1 ? (
        <ContactInformation onDone={() => onStepChange(2)} />
      ) : step === 2 ? (
        <EmployerInformation onDone={() => onStepChange(3)} />
      ) : step === 3 ? (
        <GeneralInformation onDone={() => onStepChange(4)} />
      ) : step === 4 ? (
        <BankInformation onDone={() => onStepChange(5)} />
      ) : step === 5 ? (
        <InvestmentInformation onDone={() => onStepChange(6)} />
      ) : step === 6 ? (
        <ClientClassification onDone={() => onStepChange(7)} />
      ) : step === 7 ? (
        <TaxDeclaration onDone={() => onStepChange(8)} />
      ) : step === 8 ? (
        <DocumentVault onDone={() => onStepChange(9)} />
      ) : step === 9 ? (
        <SubmitApplication setStep={onStepChange} />
      ) : null}
    </IndividualLayout>
  );
};
export default IndividualForm;
